import lottie from 'lottie-web';

if(typeof Drupal !== 'undefined') {
  Drupal.behaviors.lottiewsp = {
    attach(context) {
      once('lottie-wsp', 'html').forEach((context) => {
        initLottieVorteile(context);
      });
    }
  }
} else {
  document.addEventListener('DOMContentLoaded', function() {
      initLottieVorteile(document);
  });
}

function initLottieVorteile(context) {
  let lottieWrapper = context.querySelectorAll('.list--text-icon:has(.lottie-icon--once)');

  let wrapperObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let animations = [];
        let lottie_once = entry.target.querySelectorAll('.lottie-icon--once');

        for(let element of lottie_once) {
          animations.push(lottie.loadAnimation({
            container: element,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: element.getAttribute('data-filename') + '.json',
          }));
        }

        for(let i = 0; i < animations.length; i++) {
          (function(i) {
            setTimeout(function() {
              animations[i].play();
              lottie_once[i].closest('.list__item').querySelector('p').classList.add('fade-in');
            }, 300*i);
          })(i);
        }

        observer.unobserve(entry.target);
      }
    });
  });

  lottieWrapper.forEach((wrapper) => {
    wrapperObserver.observe(wrapper);
  });

  // for(let element of lottie_once) {
  //   animations.push(lottie.loadAnimation({
  //     container: element,
  //     renderer: 'svg',
  //     loop: false,
  //     autoplay: false,
  //     path: element.getAttribute('data-filename') + '.json',
  //   }));
  // }
  // let lottieVorteileObserver = new IntersectionObserver((entries, observer) => {
  //   entries.forEach(entry => {
  //     if(entry.isIntersecting) {
  //       for(let i = 0; i < animations.length; i++) {
  //         (function(i) {
  //           setTimeout(function() {
  //             animations[i].play();
  //             lottie_once[i].closest('.list__item').querySelector('p').classList.add('fade-in');
  //           }, 300*i);
  //         })(i);
  //       }
  //     }
  //   })
  // });

}
